import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "../../../../../../redux/store";
import type { CreateUserBody } from "@shared-kernel/application/ports/admin/admin-repository";

export const createUser = createAsyncThunk<string, CreateUserBody, { extra: Partial<Dependencies> }>(
  "admin/users/createUser",
  async (body, { extra: { adminRepository } }) => {
    return adminRepository!.createUser(body);
  },
);

export const resetCreateUser = createAction("admin/users/resetCreateUser");
